import { type MessageDescriptor, defineMessages } from '@atlassian/jira-intl';

const messages: {
	updateButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelNowOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueNowOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelMoreThan: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueMoreThanMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueMoreThanHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueMoreThanDays: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueMoreThanWeeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelDueInNext: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextExcludeOverdueMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextExcludeOverdueHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextExcludeOverdueDays: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextExcludeOverdueWeeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextDays: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueDueInNextWeeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelBetween: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelInRange: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRange: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeBeforeNowToAfterNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeBeforeNowToBeforeNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeAfterNowToAfterNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeBeforeNowToBlank: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeAfterNowToBlank: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeBlankToBeforeNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueInRangeBlankToAfterNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelIsNotSet: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelWithinTheLast: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueWithinTheLastMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueWithinTheLastHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueWithinTheLastDays: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueWithinTheLastWeeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueTimeInWeeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueTimeInDays: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueTimeInHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	valueTimeInMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationMessageInvalidPeriodFormat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationMessageBeforeGreaterThanAfter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationMessageFromGreaterThanTo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationMessageInvalidDateFormat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationMessageInvalidPeriodFormatValue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendTextIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updateButtonText: {
		id: 'jql-builder-basic-datetime.utils.update-button-text',
		defaultMessage: 'Update',
		description: 'Label of button used to update specified date criteria',
	},
	legendText: {
		id: 'jql-builder-basic-datetime.utils.legend-text',
		defaultMessage: '{fieldLabel} issues by date and time',
		description:
			'The text is shown in a legend markup located in a fieldset of datetime form, and the value fieldLabel is label of the form',
	},
	labelNowOverdue: {
		id: 'jql-builder-basic-datetime.utils.label-now-overdue',
		defaultMessage: 'Now overdue',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	valueNowOverdue: {
		id: 'jql-builder-basic-datetime.utils.value-now-overdue',
		defaultMessage: 'Now overdue',
		description:
			'Displayed as user facing value when the now overdue option is selected for datetime',
	},
	labelMoreThan: {
		id: 'jql-builder-basic-datetime.utils.label-more-than',
		defaultMessage: 'More than',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	valueMoreThanMinutes: {
		id: 'jql-builder-basic-datetime.utils.value-more-than-minutes',
		defaultMessage:
			'More than {dateNumber, plural, =0 {now} one {# minute ago} other {# minutes ago}}',
		description:
			'Displayed as user facing value when the more than option is selected for datetime',
	},
	valueMoreThanHours: {
		id: 'jql-builder-basic-datetime.utils.value-more-than-hours',
		defaultMessage: 'More than {dateNumber, plural, =0 {now} one {# hour ago} other {# hours ago}}',
		description:
			'Displayed as user facing value when the more than option is selected for datetime',
	},
	valueMoreThanDays: {
		id: 'jql-builder-basic-datetime.utils.value-more-than-days',
		defaultMessage: 'More than {dateNumber, plural, =0 {now} one {# day ago} other {# days ago}}',
		description:
			'Displayed as user facing value when the more than option is selected for datetime',
	},
	valueMoreThanWeeks: {
		id: 'jql-builder-basic-datetime.utils.value-more-than-weeks',
		defaultMessage: 'More than {dateNumber, plural, =0 {now} one {# week ago} other {# weeks ago}}',
		description:
			'Displayed as user facing value when the more than option is selected for datetime',
	},
	labelDueInNext: {
		id: 'jql-builder-basic-datetime.utils.label-due-in-next',
		defaultMessage: 'Due in next',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	valueDueInNextExcludeOverdueMinutes: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-minutes',
		defaultMessage:
			'Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}',
		description:
			'Displayed as user facing value when Due in next option and not overdue is selected for datetime',
	},
	valueDueInNextExcludeOverdueHours: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-hours',
		defaultMessage: 'Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}',
		description:
			'Displayed as user facing value when Due in next option and not overdue is selected for datetime',
	},
	valueDueInNextExcludeOverdueDays: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-days',
		defaultMessage: 'Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}}',
		description:
			'Displayed as user facing value when Due in next option and not overdue is selected for datetime',
	},
	valueDueInNextExcludeOverdueWeeks: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-weeks',
		defaultMessage: 'Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}',
		description:
			'Displayed as user facing value when Due in next option and not overdue is selected for datetime',
	},
	valueDueInNextMinutes: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-minutes',
		defaultMessage:
			'Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}} or is overdue',
		description:
			'Displayed as user facing value when Due in next or is overdue option is selected for datetime',
	},
	valueDueInNextHours: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-hours',
		defaultMessage:
			'Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}} or is overdue',
		description:
			'Displayed as user facing value when Due in next or is overdue option is selected for datetime',
	},
	valueDueInNextDays: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-days',
		defaultMessage:
			'Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}} or is overdue',
		description:
			'Displayed as user facing value when Due in next or is overdue option is selected for datetime',
	},
	valueDueInNextWeeks: {
		id: 'jql-builder-basic-datetime.utils.value-due-in-next-weeks',
		defaultMessage:
			'Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}} or is overdue',
		description:
			'Displayed as user facing value when Due in next or is overdue option is selected for datetime',
	},
	labelBetween: {
		id: 'jql-builder-basic-datetime.utils.label-between',
		defaultMessage: 'Between',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	labelInRange: {
		id: 'jql-builder-basic-datetime.utils.label-in-range',
		defaultMessage: 'In the range',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	valueInRange: {
		id: 'jql-builder-basic-datetime.utils.value-in-range',
		defaultMessage: 'From {start} to {end}',
		description:
			'Displayed in date picker text to indicate we are showing data between two relative dates, e.g. "From -3w to -1w"',
	},
	valueInRangeBeforeNowToAfterNow: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-before-now-to-after-now',
		defaultMessage: 'From {beforeTime} ago to {afterTime} from now',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeBeforeNowToBeforeNow: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-before-now-to-before-now',
		defaultMessage: 'From {beforeTime} ago to {afterTime} ago',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeAfterNowToAfterNow: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-after-now-to-after-now',
		defaultMessage: 'From {beforeTime} from now to {afterTime} from now',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeBeforeNowToBlank: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-before-now-to-blank',
		defaultMessage: 'From {beforeTime} ago',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeAfterNowToBlank: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-after-now-to-blank',
		defaultMessage: 'From {beforeTime} from now',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeBlankToBeforeNow: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-blank-to-before-now',
		defaultMessage: 'Up to {afterTime} ago',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	valueInRangeBlankToAfterNow: {
		id: 'jql-builder-basic-datetime.utils.value-in-range-blank-to-after-now',
		defaultMessage: 'Up to {afterTime} from now',
		description: 'Displayed as user facing value when date range is selected for datetime',
	},
	labelIsNotSet: {
		id: 'jql-builder-basic-datetime.utils.label-is-not-set',
		defaultMessage: 'is empty',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	labelWithinTheLast: {
		id: 'jql-builder-basic-datetime.utils.label-within-the-last',
		defaultMessage: 'Within the last',
		description: 'Label for radio button option for date picker in Basic Jql Builder',
	},
	valueWithinTheLastMinutes: {
		id: 'jql-builder-basic-datetime.utils.value-within-the-last-minutes',
		defaultMessage:
			'Within the last {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}',
		description:
			'Displayed as user facing value when within the last option is selected for datetime',
	},
	valueWithinTheLastHours: {
		id: 'jql-builder-basic-datetime.utils.value-within-the-last-hours',
		defaultMessage:
			'Within the last {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}',
		description:
			'Displayed as user facing value when within the last option is selected for datetime',
	},
	valueWithinTheLastDays: {
		id: 'jql-builder-basic-datetime.utils.value-within-the-last-days',
		defaultMessage: 'Within the last {dateNumber, plural, =0 {0 days} one {# day} other {# days}}',
		description:
			'Displayed as user facing value when within the last option is selected for datetime',
	},
	valueWithinTheLastWeeks: {
		id: 'jql-builder-basic-datetime.utils.value-within-the-last-weeks',
		defaultMessage:
			'Within the last {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}',
		description:
			'Displayed as user facing value when within the last option is selected for datetime',
	},
	valueTimeInWeeks: {
		id: 'jql-builder-basic-datetime.utils.value-time-in-weeks',
		defaultMessage: '{timeNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}',
		description: 'Time unit days',
	},
	valueTimeInDays: {
		id: 'jql-builder-basic-datetime.utils.value-time-in-days',
		defaultMessage: '{timeNumber, plural, =0 {0 days} one {# day} other {# days}}',
		description: 'Time unit days',
	},
	valueTimeInHours: {
		id: 'jql-builder-basic-datetime.utils.value-time-in-hours',
		defaultMessage: '{timeNumber, plural, =0 {0 hours} one {# hour} other {# hours}}',
		description: 'Time unit days',
	},
	valueTimeInMinutes: {
		id: 'jql-builder-basic-datetime.utils.value-time-in-minutes',
		defaultMessage: '{timeNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}',
		description: 'Time unit days',
	},
	validationMessageInvalidPeriodFormat: {
		id: 'jql-builder-basic-datetime.utils.validation-message-invalid-period-format',
		defaultMessage: 'Enter a valid number',
		description: 'Message displayed to the user when customer is not using a valid digit',
	},
	validationMessageBeforeGreaterThanAfter: {
		id: 'jql-builder-basic-datetime.utils.validation-message-before-greater-than-after',
		defaultMessage: "'Before' field cannot be later than 'After' field.",
		description:
			'Message displayed to the user when the Before date used is greater than the after date while specifying dates',
	},
	validationMessageFromGreaterThanTo: {
		id: 'jql-builder-basic-datetime.utils.validation-message-from-greater-than-to',
		defaultMessage: "'From' field cannot be later than 'To' field.",
		description:
			'Message displayed to the user when the From date period used is greater than the To date period while specifying date periods',
	},
	validationMessageInvalidDateFormat: {
		id: 'jql-builder-basic-datetime.utils.validation-message-invalid-date-format',
		defaultMessage: 'Invalid date format.',
		description: 'Invalid date format.',
	},
	validationMessageInvalidPeriodFormatValue: {
		id: 'jql-builder-basic-datetime.utils.validation-message-invalid-period-format-value',
		defaultMessage: 'Invalid period format. Please enter the period in the format "3w 4d 5h 6m".',
		description: 'Invalid period format. Please enter the period in the format "3w 4d 5h 6m".',
	},
	legendTextIssueTerminologyRefreshM4: {
		id: 'jql-builder-basic-datetime.utils.legend-text-issue-terminology-refresh-m4',
		defaultMessage: '{fieldLabel} work items by date and time',
		description:
			'The text is shown in a legend markup located in a fieldset of datetime form, and the value fieldLabel is label of the form',
	},
});
export default messages;
// Used to dynamically lookup message descriptors while keeping TS happy.
export const messageLookup: { [key: string]: MessageDescriptor | undefined } = messages;
